import styled from "styled-components";

export const MapContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 40px auto;
  padding: 0 20px;

  .map-responsive {
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    height: 0;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  }

  .map-responsive iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    border: 0;
    border-radius: 12px;
  }
`;
